// src/context/LoaderContext.jsx
import React, { createContext, useState, useContext, useEffect } from "react";
import { registerGlobalLoader } from "./LoaderController";
import GlobalLoader from "../components/GlobalLoader";

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // register our setter so the controller can toggle it
    registerGlobalLoader(setLoading);

    // cleanup: unregister on unmount
    return () => {
      registerGlobalLoader(null);
    };
  }, []);

  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      {children}
      <GlobalLoader />
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);
